(function () {
  // Cart responses already include the upsell snippet in the drawer section.
  // Refresh from that markup instead of fetching the page on every DOM change.
  window.refreshCartDrawerUpsells = function (sectionHTML) {
    const sourceDocument = typeof sectionHTML === 'string'
      ? new DOMParser().parseFromString(sectionHTML, 'text/html')
      : sectionHTML || document;
    const source = sourceDocument.querySelector('#cart-drawer-upsell-wrapper');
    if (!source) return;

    const currentSource = document.querySelector('#cart-drawer-upsell-wrapper');
    if (source !== currentSource && currentSource) {
      currentSource.replaceChildren(...source.cloneNode(true).childNodes);
    }

    const drawer = document.querySelector('#CartDrawer');
    const cartItems = drawer?.querySelector('cart-drawer-items');
    if (!cartItems) return;

    let wrapper = drawer.querySelector('.cart-drawer-items-wrapper');
    wrapper?.querySelector('#cart-drawer-upsell')?.remove();
    if (cartItems.classList.contains('is-empty')) return;

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'cart-drawer-items-wrapper';
      cartItems.before(wrapper);
      wrapper.appendChild(cartItems);
    }

    const upsells = source.querySelector('#cart-drawer-upsell');
    if (upsells?.querySelector('.cart-drawer-upsell-list li')) {
      wrapper.appendChild(upsells.cloneNode(true));
    }
  };

  window.onChangeKsUpsellVariantSelector = function (select, event) {
    event.preventDefault();
    const imgSrc = select.options[select.selectedIndex]?.dataset.variantImg;
    const img = select.closest('.cart-drawer-upsell-list-item')
      ?.querySelector('.cart-drawer-upsell-list-item-left img');
    if (imgSrc && img) img.src = imgSrc;
  };

  window.refreshCartDrawerUpsells();
})();
